<template>
    <div class="page-main common">
        <a-tabs>
            <a-tab-pane tab="开票信息" >
                <div class="common-form-inline">
                    <a-form-model
                    ref="oiForm"
                    :model="oiInfo"
                    :rules="oiRules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
                    >
                        <a-row :gutter="24">
                            <a-col :span="12">
                                <a-form-model-item label="企业名称" prop="customerName">
                                    <a-input v-model="oiInfo.customerName" :maxLength="30" :disabled="isDetail"/>
                                    <span class="form-input-len">{{oiInfo.customerName?oiInfo.customerName.length:0}}/30</span>
                                </a-form-model-item>
                                
                            </a-col>
                            <a-col :span="12">
                                <a-form-model-item label="纳税人识别号" prop="taxpayerIdentityNumber">
                                    <a-input v-model="oiInfo.taxpayerIdentityNumber" :maxLength="20" :disabled="isDetail"/>
                                    <span class="form-input-len">{{oiInfo.taxpayerIdentityNumber?oiInfo.taxpayerIdentityNumber.length:0}}/20</span>
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        <a-row :gutter="24">
                            <a-col :span="12">
                            <a-form-model-item label="地址" prop="customerAddress">
                                    <a-input v-model="oiInfo.customerAddress" :maxLength="50" :disabled="isDetail"/>
                                    <span class="form-input-len">{{oiInfo.customerAddress?oiInfo.customerAddress.length:0}}/50</span>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-model-item label="电话" prop="customerPhone">
                                    <a-input v-model="oiInfo.customerPhone" :maxLength="20" :disabled="isDetail"/>
                                    <span class="form-input-len">{{oiInfo.customerPhone?oiInfo.customerPhone.length:0}}/20</span>
                                </a-form-model-item>
                            </a-col>
                        </a-row>    
                        <a-row :gutter="24">
                            <a-col :span="12">
                                <a-form-model-item label="开户行" prop="depositBank">
                                    <a-input v-model="oiInfo.depositBank" :maxLength="30" :disabled="isDetail"/>
                                    <span class="form-input-len">{{oiInfo.depositBank?oiInfo.depositBank.length:0}}/30</span>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-model-item label="账号" prop="accountNumber">
                                    <a-input v-model="oiInfo.accountNumber" :maxLength="20" :disabled="isDetail"/>
                                    <span class="form-input-len">{{oiInfo.accountNumber?oiInfo.accountNumber.length:0}}/20</span>
                                </a-form-model-item>
                            </a-col>
                        </a-row>  
                    </a-form-model>
                </div>
            </a-tab-pane>
        </a-tabs>
        <a-tabs>
            <a-tab-pane tab="接收信息"  style="margin-bottom:30px">
                <div class="common-form-inline">
                    <a-form-model
                    ref="rcvrForm"
                    :model="oiInfo"
                    :rules="oiRules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
                    >
                        <a-row :gutter="24">
                            <a-col :span="12">
                                <a-form-model-item label="收件人" prop="receiverName">
                                    <a-input v-model="oiInfo.receiverName" :maxLength="10" :disabled="isDetail"/>
                                    <span class="form-input-len">{{oiInfo.receiverName?oiInfo.receiverName.length:0}}/10</span>
                                </a-form-model-item>
                                
                            </a-col>
                            <a-col :span="12">
                                <a-form-model-item label="电话" prop="receivePhone">
                                    <a-input v-model="oiInfo.receivePhone" :maxLength="20" :disabled="isDetail"/>
                                    <span class="form-input-len">{{oiInfo.receivePhone?oiInfo.receivePhone.length:0}}/20</span>
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        <a-row :gutter="24">
                            <a-col :span="12">
                            <a-form-model-item label="地址" prop="receiverAddress">
                                    <a-input v-model="oiInfo.receiverAddress" :maxLength="50" :disabled="isDetail"/>
                                    <span class="form-input-len">{{oiInfo.receiverAddress?oiInfo.receiverAddress.length:0}}/50</span>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-model-item label="电子发票接收邮箱" prop="einvoiceReceiveMail">
                                    <a-input v-model="oiInfo.einvoiceReceiveMail" :maxLength="20" :disabled="isDetail"/>
                                    <span class="form-input-len">{{oiInfo.einvoiceReceiveMail?oiInfo.einvoiceReceiveMail.length:0}}/20</span>
                                </a-form-model-item>
                            </a-col>
                        </a-row>     
                    </a-form-model>
                </div>
            </a-tab-pane>
        </a-tabs>
        <div class="spaceCenter model-footer-btns">
            <a-button @click="goback" class="btn-blue-line btn-big">返回</a-button>
            <a-button v-if="!isDetail" @click="save" class="btn-big" type="primary">保存</a-button>
        </div>
    </div>
</template>

<script>
import {getUserInfo,getInvoiceInfo,updateInvoiceInfo} from "@/api/security.js"
export default {
    props:["isDetail"],
    name:"updateoi",
    data() {
        return {
            labelCol: { span: 9 },
            wrapperCol: { span: 15 },
            orgCode:"",
            oiInfo:{
                customerName:"",
                taxpayerIdentityNumber:"",
                customerAddress:"",
                customerPhone:"",
                depositBank:"",
                accountNumber:"",
                receiverName:"",
                receivePhone:"",
                receiverAddress:"",
                einvoiceReceiveMail:"",
            },
            oiRules:{
                customerName:{
                    required: true, 
                    message: '请填写企业名称'
                },
                taxpayerIdentityNumber:{
                    required: true, 
                    message: '请填写纳税人识别号'
                },
                customerAddress:{
                    required: true, 
                    message: '请填写地址'
                },
                customerPhone:{
                    required: true,
                    message: '请填写电话'
                },
                depositBank:{
                    required: true, 
                    message: '请填写开户行'
                },
                accountNumber:{
                    required: true, 
                    message: '请填写账号'
                },
                receiverName:{
                    required: true, 
                    message: '请填写收件人'
                },
                receivePhone:{
                    required: true, 
                    message: '请填写电话'
                },
                receiverAddress:{
                    required: true,
                    message: '请填写地址'
                },
                einvoiceReceiveMail:{
                    required: true, 
                    message: '请填写电子发票接收邮箱'
                },
            },
        };
    },
    computed: {},
    methods: {
        getUserInfo(){
            getUserInfo(null,true)
            .then(res => {
                this.orgCode = res.data.orgCode;
                const params = { orgCode: this.orgCode };
                getInvoiceInfo(params).then(resData => {
                    this.oiInfo = resData.data || {};
                }).catch(error => {
                    console.log(error);
                })
            })
            .catch(err => {
                console.log(err);
            })
        },
        goback(){
            this.$router.go(-1);
        },
        save(){
            let flag1 = false, flag2 = false;
            this.$refs.oiForm.validate((valid) => flag1 = valid)
            this.$refs.rcvrForm.validate((valid) => flag2 = valid)
            if(flag1 && flag2){
                const params = Object.assign(this.oiInfo,{orgCode:this.orgCode});
                updateInvoiceInfo(params,true).then(res => {
                    this.$message.success("修改成功");
                    this.goback();
                }).catch(err => {
                    console.log(err);
                })
            }
        }
    },
    created() {
        this.getUserInfo();
    },
    watch: {},
};
</script>
<style scoped>
.form-input-len{
    font-size: 12px;
    color:#666;
    position: absolute;
    right: 0;
    top:12px;
}
</style>


// WEBPACK FOOTER //
// src/pages/security/vertify/updateoi.vue